module.exports = require("@glimmer/manager");